module.exports = __webpack_public_path__ + "img/img-3-6mobile.13251443.png";